import React, { useMemo } from 'react';
import { IValidation, Validation } from '../../../utils/Validation';

export interface FieldProps {
	validation?: IValidation;
	value: any;
}

export function useValidation(value: any, validation?: IValidation) {
	const isValid = useMemo(() => {
		if (!validation) return true;
		return new Validation(validation).assert(value);
	}, [value, validation]);

	const nonValidMessage = useMemo(() => {
		if (isValid || !validation) return null;
		const rule = validation.rules?.find((r) => !r.assert(value));
		if (!rule) return '';
		return typeof rule.message === 'string' ? rule.message : rule.message(value);
	}, [isValid, value, validation]);

	return { isValid, nonValidMessage };
}
